import React, { useState } from "react";
import MessageItem from "./StripMessageItem";
import { useGetCollectPaymentContext } from "../context";

const PaymentModeTopStrip = ({module}) => {
  const { studentBasicDetails } = useGetCollectPaymentContext(module);
  const content = studentBasicDetails?.detailsMap?.discHeaderMsgForPaymentModePage;
  
  const [isDeleted, setIsDeleted] = useState(true);
  if (!content || !isDeleted) return <div></div>;
  const mgsList = [{ content, isWarning: true }];

  const deleteHandler = () => {
    setIsDeleted(false);
  };

  return mgsList.map((item, index) => (
    <MessageItem
      key={index}
      item={item}
      isRemoveMy={false}
      onDelete={() => deleteHandler(index)}
    />
  ));
};

export default PaymentModeTopStrip;
